import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useModuleIds } from 'portal/lib/hooks'
import { loadHistory } from 'portal/store/records/history/actions'

export const useRecordHistoryLoader = () => {
  const dispatch = useDispatch()
  const { accountId, projectId, moduleName, recordId } = useModuleIds()

  const reload = useCallback(() => {
    if (!accountId || !projectId || !moduleName || !recordId) {
      return
    }
    dispatch(loadHistory(accountId, projectId, moduleName, recordId))
  }, [dispatch, accountId, projectId, moduleName, recordId])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, items } = useSelector((state: any) => {
    return state.records.history
  })

  return {
    loading,
    error,
    items,
    reload
  }
}
